import { useEffect, useState } from "react";
import { ISendMessage, IUser, RootState } from "../../redux/type";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { SendMessageAction, deleteUserInDatabase, showAllUsers } from "../../redux/createMessage/slice";
import Button from "../UI/Button";
import Modal from "../modals/DeleteUserModal";

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default function UsersPage() {
  const dispatch = useDispatch()
  const [searchInput, setSearchInput] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUserIdToDelete, setSelectedUserIdToDelete] = useState("");

  const { users, loading, error, usersPerPage, currentPage } = useAppSelector((state) => state.sendMessage);
  useEffect(() => {
    dispatch(showAllUsers())
    dispatch(SendMessageAction.onClickCurrentPage(1))
  }, [])

  //client don't want this functionality
  // const handleToggleUserStatus = async (user: any) => {
  //   if (user.Active_Status) {
  //     dispatch(unblockUserInDatabase(user));
  //   } else {
  //     dispatch(blockUserInDatabase(user));
  //   }
  // };

  const handleSearchChange = (e: any) => {
    setSearchInput(e.target.value)
    dispatch(SendMessageAction.onClickCurrentPage(1));

  }

  const handleOpenModal = (userId: string) => {
    setSelectedUserIdToDelete(userId);
    setModalOpen(true)
  }

  if (loading) {
    return (<h2>Loading Data...</h2>)
  }
  if (error) {
    return <h2>Error: {error}</h2>;
  }

  const filteredUsers = users.filter((user) => user.Email && user.Email.includes(searchInput));
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const indexOfLastPage = currentPage * usersPerPage;
  const indexOfFirstPage = indexOfLastPage - usersPerPage;
  const VisibleUsers = filteredUsers.slice(indexOfFirstPage, indexOfLastPage);

  const navigatePrev = () => {
    if (currentPage !== 1) {
      dispatch(SendMessageAction.onNavigatePrev())
    }
  }
  const navigateNext = () => {
    if (currentPage !== totalPages) {
      dispatch(SendMessageAction.onNavigateNext())
    }
  }
  const handleCurrentPage = (index: any) => {
    dispatch(SendMessageAction.onClickCurrentPage(index))
  }



  //pagination button
  const renderButtons = () => {
    const buttons = [];

    const startPage = Math.max(1, currentPage - 1);  //current page is 1

    const endPage = Math.min(startPage + 2, totalPages);

    //for first button
    if ((startPage > 1) && (currentPage > 3)) {
      buttons.push(
        <button
          key={1}
          className={`btn paginationButton ${1 === currentPage ? "currentPageButton" : ""}`}
          onClick={() => handleCurrentPage(1)}
        >
          {1}
        </button>
      );
      buttons.push(
        <span key="dots-first" className="dots">
          . . .
        </span>
      );
    }


    for (let index = startPage; index <= endPage; index++) {
      buttons.push(
        <button
          key={index}
          className={` btn paginationButton ${index === currentPage ? "currentPageButton" : ""}`}
          onClick={() => handleCurrentPage(index)}
        >
          {index}
        </button>
      );
    }

    //for last button
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        buttons.push(
          <span key="dots" className="dots">
            . . .
          </span>
        );
      }

      buttons.push(
        <button
          key={totalPages}
          className={`btn paginationButton ${totalPages === currentPage ? "currentPageButton" : ""}`}
          onClick={() => handleCurrentPage(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    return buttons;
  };


  return (
    <main>
      <div className="container-fluid px-4">

        <div>
          <h1>Users</h1>
        </div>
        <div className="filterInputs">
          <div>
            <span>Filter Options:</span>
            <input
              type="text"
              placeholder="Search by Email"
              value={searchInput}
              onChange={handleSearchChange}
            />
            <button className=" btn btn-sm btn-secondary" onClick={() => setSearchInput("")}>Clear Search</button>
          </div>
          <span style={{ color: "red" }}>Total users: {users.length}</span>
        </div>
        <div className="mb-4">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Email ID</th>
                  <th>Coins</th>
                  {/* <th>Account Status</th>
                  <th>Block/Unblock Account</th> */}
                  {/* <th>Delete User</th> */}

                </tr>
              </thead>
              <tbody>

                {VisibleUsers
                  .filter((user) => user.Email && user.Email.includes(searchInput))
                  .map((user: IUser) => (
                    <tr key={user.Id}>
                      <td>{user.UserName.trim() === "" ? "No Username" : user.UserName}</td>
                      <td>{user.Email}</td>
                      <td>{user.Coins}</td>
                      {/* <td>{user.Active_Status ? 'Active' : 'Blocked'}</td> */}

                      {/* <td className="text-center">
                      <Button text={user.Active_Status ? "Block" : "Unblock"}                       
                              className={`btn ${user.Active_Status ? "btn-success" : "btn-danger"}`}
                              onClick={() => handleToggleUserStatus(user)}/>
                    </td>   */}
                      {/* <td className="">
                      <Button text= "Delete"                       
                              className={`btn btn-dark`}
                              onClick={() => handleOpenModal(user.Id) }
                              />
                    </td> */}
                      {modalOpen && <Modal userId={selectedUserIdToDelete} setOpenModal={setModalOpen} />}

                    </tr>
                  ))}

              </tbody>
            </table>
          </div>
          <div>
            <span className="btn paginationButton" onClick={() => navigatePrev()}>Prev</span>
            <span>{renderButtons()}</span>
            <span className="btn paginationButton" onClick={() => navigateNext()}>Next</span>
            <p style={{ padding: "0.375rem 0.75rem" }}>Current Page is {currentPage} of {totalPages}</p>

          </div>
        </div>

      </div>

    </main>
  );
}
